/**
 * Seeded random number generation, shared by the server and the web client.
 *
 * The server uses these to split scenario bodies into token deltas
 * deterministically. The web client uses them for randomizer mode and for
 * seeded reconnect jitter, so a run reproduces exactly when the same seed is
 * given. Both sides need the same generator, and the web cannot import the
 * server package, which is why this lives here in the zero dependency
 * protocol package.
 */

/**
 * mulberry32. A small, fast, seeded generator.
 *
 * The point is not statistical quality, it is reproducibility: the same seed
 * gives the same sequence on every machine and every run, so a scenario splits
 * its text the same way forever.
 */
export function createRandom(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** A stable seed from a scenario id, so the seed does not have to be written down. */
export function seedFromId(id: string): number {
  let h = 2166136261;
  for (let i = 0; i < id.length; i += 1) {
    h ^= id.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
